import getDoc from '../../utils/db/getDoc'
import mapCampaignLinkDetail from './mapCampaignLinkDetail'

const getCampaignLink = async (id) => {
  const docId = typeof id === 'string' ? id.trim() : ''

  if (!docId) {
    return {
      ok: false,
      message: 'Не вказано id посилання',
    }
  }

  try {
    const data = await getDoc({ path: 'campaign_links', docId, docIdName: 'id' })

    if (!data) {
      return {
        ok: false,
        message: 'Посилання не знайдено',
      }
    }

    return {
      ok: true,
      data: mapCampaignLinkDetail(data.id, data),
    }
  } catch (error) {
    console.error('[getCampaignLink] failed:', error)

    const code = typeof error?.code === 'string' ? error.code : ''
    const message =
      code === 'permission-denied'
        ? 'Немає доступу до цього посилання'
        : error?.message || 'Не вдалося завантажити посилання'

    return {
      ok: false,
      message,
    }
  }
}

export default getCampaignLink
